import { createActions } from 'reduxsauce'
 
export const { Types, Creators } = createActions({
  saveLineId: ['lineId'],

  fetchGeojsonData: null,
  fetchGeojsonDataSuccess: ['responseData'],
  fetchGeojsonDataFailure: ['error']
  
}, {});
